import React, { ReactNode, CSSProperties } from 'react';
import cx from 'classnames';

import './gradient-overlay.css';

interface Props {
    addStyles?: CSSProperties;
    children?: ReactNode;
    color: 'aqua' | 'purple';
}

export const GradientOverlay = ({
    addStyles = {},
    children,
    color,
}: Props): JSX.Element => {
    const classNames = cx(
        'gradient-overlay',
        'absolute',
        'z-10',
        'left-0',
        'right-0',
        color,
    );

    return (
        <div className="relative w-full">
            <div className={classNames} style={addStyles}>
                {children}
            </div>
        </div>
    );
};
